<template>
    <div :class="classNames">
        <div :class="commonName+ '_search'">
            <div :class="commonName+ '_search_con'">
                <div :class="commonName+ '_search_con_item'">
                   <el-button type="primary" @click="toAdd">
                       添加讲解卡
                   </el-button>
                </div>
                <div :class="commonName+ '_search_con_item'">
                    <span :class="commonName+ '_search_con_item_title'">状态</span>
                    <el-select v-model="searchObj.status">
                        <el-option v-for="(item, index) in statusList" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                </div>
                <div :class="commonName+ '_search_con_item'">
                    <span :class="commonName+ '_search_con_item_title'">课程标题</span>
                    <el-input placeholder="请输入课程标题" style="width: 240px" v-model="searchObj.title"></el-input>
                </div>
				<div :class="[commonName+ '_search_con_item', commonName+ '_oprtation']">
					<el-button type="primary" @click="searchRes">查询</el-button>
				</div>
			</div>
        </div>
        <div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="tableData.list"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
                    <el-table-column v-for="(item, index) in headerList" :key="index" :prop="item.prop" :label="item.label" :width="item.width" :align="item.align">
						<template slot-scope="scope">
                            <div v-if="item.prop=='cover'">
                                <el-image 
                                    style="width: 100px; height: 100px"
                                    fit="cover"
                                    :src="scope.row[item.prop]" 
                                    :preview-src-list="[scope.row[item.prop]]">
                                </el-image>
                            </div>
                            <div v-else-if="item.prop == 'dy_product_status'">
                                {{ statusObj[scope.row[item.prop]].label }}
                                <el-tooltip
                                    v-if="statusObj[scope.row[item.prop]].showRejectReason" 
                                    class="item" 
                                    effect="dark" 
                                    :content="`驳回原因：${scope.row.reason||''}`" 
                                    placement="top-start">
                                    <div class="rejection-box">
                                        驳回原因：{{ scope.row.reason||'' }}
                                    </div>
                                </el-tooltip>
                            </div>
                            <div v-else>{{scope.row[item.prop] || '--'}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="60" fixed="right">
						<template slot-scope="scope">
                            <div class="operate-box">
                                <div class="operate-item" :class="commonName+'_operation_title'"  @click="handleOperate(1, scope.row)">编辑</div>
                                <div class="operate-item" :class="commonName+'_operation_title'"  @click="handleOperate(2, scope.row)">删除</div>
                            </div>
						</template>
					</el-table-column>
				</el-table>
			</div>
            <Pagination @change="changeSize" :total="tableData.total" ref="pagination" v-model="searchObj.page" v-if="tableData.total>0"></Pagination>
		</div>
    </div>
</template>

<script>
    import { headerList } from './data.js'
    import { breadcrumbsMixin } from '@/components/mixin/mixin.js'
    import { mapActions } from 'vuex'
    export default {
        data(){
            return {
                classNames: 'comment',
                noDataName: 'empty',
                headerList: headerList,
                tableData: {// 表格数据
                    toltal: 0,
                    list: []
                },
                searchObj: {
                    page: 1,
                    limit: 10,
                    status: '', //「1」待推送「2」审核中「3」审核完成「4」审核失败
                    title: '' //课程标题
                },
                statusList: [ // 状态筛选项
                    {value: '',label: '全部'},
                    {value: 1,label: '待推送'},
                    {value: 2,label: '审核中'},
                    {value: 3,label: '审核完成'},
                    {value: 4,label: '审核失败'},
                ],
                statusObj: {
                    1: {label: '待推送'},
                    2: {label: '审核中'},
                    3: {label: '审核完成'},
                    4: {label: '审核失败', showRejectReason: true},
                }
            }
        },
        mixins: [breadcrumbsMixin],
        created(){
            this.getTableData(true)
        },
        methods: {
            ...mapActions('explainCard',['getExplainCardListAPI','addEditDelExplainCardAPI']),
            toAdd(){
                this.mixin_handleBreadCrumb(this.staticPath + 'addExplainCard', '添加讲解卡')
            },
            searchRes() {
                this.getTableData(true)
            },
            // 获取表格数据
            async getTableData(flag){
                if (flag) {
                    this.searchObj.page = 1;
                }
                let res = await this.getExplainCardListAPI(this.searchObj)
                this.tableData.list = res.list || []
                this.tableData.total = res.page_info?.total_count || 0
            },
            changeSize(size) {
                this.searchObj.page = size
                this.getTableData()
            },
            // 操作
            handleOperate(type, item){
                if(type==1){ // 编辑
                    console.log('item:',item)
                    let queryObj = {
                        id: item.id || '',
                        cid: item.product_id || '', // 课程id
                        title: item.anchor_title  || '', //讲解卡锚点标题
                        ctitle: item.title || '', // 课程标题
                        pic: item.cover || '', // 讲解卡图片
                        cpic: item.list_width_img || '', // 课程图片
                    }
                    let str = '?'
                    for(let k in queryObj){
                        str += (`${k}=${encodeURIComponent(queryObj[k])}&`)
                    }
                    str = str.substring(0, str.length - 1)
                    // console.log('str:',str)
                    this.mixin_handleBreadCrumb(this.staticPath + 'addExplainCard'+str, '编辑讲解卡')
                }
                if(type==2){ // 删除
                    this.$confirm('确定要删除吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    })
                    .then(async() => {
                        await this.addEditDelExplainCardAPI({
                            id: item.id,
                            is_del: 1
                        })
                        this.$message({
                            type: 'success',
                            message: '删除成功',
                            duration: 3000
                        })
                        if(
                            this.tableData.total>10 && 
                            this.tableData.total%10===1 && 
                            this.searchObj.page >1
                        ){
                            this.searchObj.page--
                            this.getTableData()
                        }else{
                            this.getTableData(true)
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .operate-box{
        display: inline-flex;
        flex-direction: column;
        .operate-item{
            margin-top: 2px;
        }
    }
    .rejection-box{
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
    }
</style>